<template>
  <v-container class="fill-height pa-0">
    <v-row class="" dense>
      <v-col cols="12">
        <navTabs />
      </v-col>
    </v-row>
    <router-view />
  </v-container>
</template>

<script>
import navTabs from '@/components/common/ui/navTabs.vue'
export default {
  components: {
    navTabs
  },
  data () {
    return {

    }
  },
  methods: {

  }

}
</script>
